import service from '@/utils/request'; // getSpecialOrderList 获取卸油信息列表
// @Tags orderManage
// @Summary 分页获取卸油信息列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取获取卸油信息列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/special/getList [get]

export var getOilManageTankinList = function getOilManageTankinList(params) {
  return service({
    url: '/oilManage/tankin/getList',
    method: 'get',
    params: params
  });
}; // bairunSpecialOrderCheck 卸油信息状态更新
// @Tags orderManage
// @Summary 卸油信息状态更新
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "卸油信息状态更新"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /orderManage/special/check [post]

export var postOilManageTankinUpdate = function postOilManageTankinUpdate(data) {
  return service({
    url: '/oilManage/tankin/update',
    method: 'post',
    data: data
  });
}; // getSpecialOrderList 获取卸油信息详情列表
// @Tags orderManage
// @Summary 获取卸油信息详情列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "获取卸油信息详情列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/special/getList [get]

export var getOilManageTankinDetailList = function getOilManageTankinDetailList(params) {
  return service({
    url: '/oilManage/tankin/detail/getList',
    method: 'get',
    params: params
  });
}; // bairunSpecialOrderCheck 保存与提交液位仪数据
// @Tags orderManage
// @Summary 保存与提交液位仪数据
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "保存与提交液位仪数据"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /orderManage/special/check [post]

export var postOilManageTankinDetailUpdate = function postOilManageTankinDetailUpdate(data) {
  return service({
    url: '/oilManage/tankin/detail/update',
    method: 'post',
    data: data
  });
}; // getSpecialOrderList 获取运输单号列表
// @Tags orderManage
// @Summary 分页获取运输单号列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取运输单号列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/special/getList [get]

export var getOilManageTransportList = function getOilManageTransportList(params) {
  return service({
    url: '/oilManage/transport/getList',
    method: 'get',
    params: params
  });
}; // bairunSpecialOrderCheck 运输单号创建
// @Tags orderManage
// @Summary 运输单号创建
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "运输单号创建"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /orderManage/special/check [post]

export var postOilManageTransportCreate = function postOilManageTransportCreate(data) {
  return service({
    url: '/oilManage/transport/create',
    method: 'post',
    data: data
  });
}; // getSpecialOrderList 获取供应商列表
// @Tags orderManage
// @Summary 获取供应商列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "获取供应商列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/special/getList [get]

export var getOilManageSupplierList = function getOilManageSupplierList(params) {
  return service({
    url: '/oilManage/supplier/getList',
    method: 'get',
    params: params
  });
}; // getSpecialOrderList 获取油库列表
// @Tags orderManage
// @Summary 获取油库列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "获取油库列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/special/getList [get]

export var getOilManageOildepotList = function getOilManageOildepotList(params) {
  return service({
    url: '/oilManage/oildepot/getList',
    method: 'get',
    params: params
  });
}; // getSpecialOrderList 获取车队列表
// @Tags orderManage
// @Summary 获取车队列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "获取车队列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/special/getList [get]

export var getOilManageFleetList = function getOilManageFleetList(params) {
  return service({
    url: '/oilManage/fleet/getList',
    method: 'get',
    params: params
  });
}; // getSpecialOrderList 获取车辆列表
// @Tags orderManage
// @Summary 获取车辆列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "获取车辆列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/special/getList [get]

export var getOilManageFleetcarList = function getOilManageFleetcarList(params) {
  return service({
    url: '/oilManage/fleetcar/getList',
    method: 'get',
    params: params
  });
}; // getSpecialOrderList 获取司机列表
// @Tags orderManage
// @Summary 获取司机列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "获取司机列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/special/getList [get]

export var getOilManageFleetdriverList = function getOilManageFleetdriverList(params) {
  return service({
    url: '/oilManage/fleetdriver/getList',
    method: 'get',
    params: params
  });
}; // getSpecialOrderList 获取操作时间附近液位仪列表
// @Tags orderManage
// @Summary 获取操作时间附近液位仪列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "获取操作时间附近液位仪列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /orderManage/special/getList [get]

export var getOilManageTankinSequenceList = function getOilManageTankinSequenceList(params) {
  return service({
    url: '/oilManage/tankin/sequence/getList',
    method: 'get',
    params: params
  });
}; // getShiftTankRecordList 获取班结分罐保管登记帐列表
// @Tags orderManage
// @Summary 获取班结分罐保管登记帐列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "获取班结分罐保管登记帐列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /oilManage/tank/shift/getList [get]

export var getShiftTankRecordList = function getShiftTankRecordList(params) {
  return service({
    url: '/oilManage/tank/shift/getList',
    method: 'get',
    params: params
  });
}; // getDayTankRecordList 获取日结分罐保管登记帐列表
// @Tags orderManage
// @Summary 获取日结分罐保管登记帐列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "获取日结分罐保管登记帐列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /oilManage/tank/daily/getList [get]

export var getDayTankRecordList = function getDayTankRecordList(params) {
  return service({
    url: '/oilManage/tank/daily/getList',
    method: 'get',
    params: params
  });
}; // updateShiftTankRecord 更新班结分罐保管登记帐列表
// @Tags orderManage
// @Summary 更新班结分罐保管登记帐列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "更新班结分罐保管登记帐列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /oilManage/tank/shift/update [post]

export var updateShiftTankRecord = function updateShiftTankRecord(data) {
  return service({
    url: '/oilManage/tank/shift/update',
    method: 'post',
    data: data
  });
}; // updateDayTankRecord 更新日结分罐保管登记帐列表
// @Tags orderManage
// @Summary 更新日结分罐保管登记帐列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "更新日结分罐保管登记帐列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /oilManage/tank/daily/update [post]

export var updateDayTankRecord = function updateDayTankRecord(data) {
  return service({
    url: '/oilManage/tank/daily/update',
    method: 'post',
    data: data
  });
}; // getPurchaseCheckList 油品盘点-采购
// @Tags orderManage
// @Summary 油品盘点-采购
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "油品盘点-采购"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /oilManage/oilcode/daily/getList [get]

export var getPurchaseCheckList = function getPurchaseCheckList(params) {
  return service({
    url: '/oilManage/oilcode/daily/getList',
    method: 'get',
    params: params
  });
}; // createPurchaseCheck 新增油品盘点-采购
// @Tags orderManage
// @Summary 新增油品盘点-采购
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "新增油品盘点-采购"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /oilManage/oilcode/daily/create/tankin [post]

export var createPurchaseCheck = function createPurchaseCheck(data) {
  return service({
    url: '/oilManage/oilcode/daily/create/tankin',
    method: 'post',
    data: data
  });
}; // updatePurchaseCheck 更新油品盘点-采购
// @Tags orderManage
// @Summary 更新油品盘点-采购
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "更新油品盘点-采购"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /oilManage/oilcode/daily/update/tankin [post]

export var updatePurchaseCheck = function updatePurchaseCheck(data) {
  return service({
    url: '/oilManage/oilcode/daily/update/tankin',
    method: 'post',
    data: data
  });
}; // deletePurchaseCheck 删除油品盘点-采购
// @Tags orderManage
// @Summary 删除油品盘点-采购
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除油品盘点-采购"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /oilManage/oilcode/daily/delete/tankin [post]

export var deletePurchaseCheck = function deletePurchaseCheck(data) {
  return service({
    url: '/oilManage/oilcode/daily/delete/tankin',
    method: 'post',
    data: data
  });
}; // getStationCheckList 油品盘点-油站
// @Tags orderManage
// @Summary 油品盘点-油站
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "油品盘点-油站"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /oilManage/oilcode/daily/getList [get]

export var getStationCheckList = function getStationCheckList(params) {
  return service({
    url: '/oilManage/oilcode/daily/getList',
    method: 'get',
    params: params
  });
}; // createStationCheck 新增油品盘点-油站
// @Tags orderManage
// @Summary 新增油品盘点-油站
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "新增油品盘点-油站"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /oilManage/oilcode/daily/create/sequence [post]

export var createStationCheck = function createStationCheck(data) {
  return service({
    url: '/oilManage/oilcode/daily/create/sequence',
    method: 'post',
    data: data
  });
}; // updateStationCheck 更新油品盘点-油站
// @Tags orderManage
// @Summary 更新油品盘点-采购
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "更新油品盘点-油站"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /oilManage/oilcode/daily/update/sequence [post]

export var updateStationCheck = function updateStationCheck(data) {
  return service({
    url: '/oilManage/oilcode/daily/update/sequence',
    method: 'post',
    data: data
  });
}; // deleteStationCheck 删除油品盘点-采购
// @Tags orderManage
// @Summary 删除油品盘点-采购
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除油品盘点-采购"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /oilManage/oilcode/daily/delete/sequence [post]

export var deleteStationCheck = function deleteStationCheck(data) {
  return service({
    url: '/oilManage/oilcode/daily/delete/sequence',
    method: 'post',
    data: data
  });
}; // getOilDayCheckList 油品盘点-按日
// @Tags orderManage
// @Summary 油品盘点-按日
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "油品盘点-按日"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /oilManage/oilcode/daily/getList [get]

export var getOilDayCheckList = function getOilDayCheckList(params) {
  return service({
    url: '/oilManage/oilcode/daily/getList',
    method: 'get',
    params: params
  });
}; // updateOilDayCheck 更新油品盘点-按日
// @Tags orderManage
// @Summary 更新油油品盘点-按日
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "更新油品盘点-按日"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /oilManage/oilcode/daily/update [post]

export var updateOilDayCheck = function updateOilDayCheck(data) {
  return service({
    url: '/oilManage/oilcode/daily/update',
    method: 'post',
    data: data
  });
}; // updateOilDayTask 更新油品盘点-按日重新计算
// @Tags orderManage
// @Summary 更新油油品盘点-按日重新计算
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "更新油品盘点-按日重新计算"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /oilManage/oilcode/daily/task [post]

export var updateOilDayTask = function updateOilDayTask(data) {
  return service({
    url: '/oilManage/oilcode/daily/task',
    method: 'post',
    data: data
  });
}; // getOilMoneyCheckList 油品盘点-按月
// @Tags orderManage
// @Summary 油品盘点-按月
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "油品盘点-按月"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /oilManage/oilcode/daily/getList [get]

export var getOilMoneyCheckList = function getOilMoneyCheckList(params) {
  return service({
    url: '/oilManage/oilcode/daily/getList',
    method: 'get',
    params: params
  });
}; // DownloadOilCheckMonth 油品盘点-按月下载
// @Tags orderManage
// @Summary 油品盘点-按月下载
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "油品盘点-按月下载"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /oilManage/oilcode/daily/download [post]

export var downloadOilCheckMonth = function downloadOilCheckMonth(data) {
  return service({
    url: '/oilManage/oilcode/daily/download',
    method: 'post',
    data: data
  });
}; // downloadOilCheckDay 油品盘点-按日下载
// @Tags orderManage
// @Summary 油品盘点-按日下载
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "油品盘点-按日下载"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /oilManage/oilcode/daily/download/days/detail [post]

export var downloadOilCheckDay = function downloadOilCheckDay(data) {
  return service({
    url: '/oilManage/oilcode/daily/download/days/detail',
    method: 'post',
    data: data
  });
};